import React from 'react'
import { NimblePicker } from 'emoji-mart'
import data from 'emoji-mart/data/messenger.json'

const Picker = props => (
  <NimblePicker
    set='messenger'
    size={32}
    sheetSize={20}
    emojiSize={22}
    exclude={['foods', 'activity', 'places', 'flags', 'symbols']}
    showPreview={false}
    showSkinTones={false}
    native={true}
    darkMode={false}
    data={data}
    perLine={props.isWidget ? 8 : 9}
    {...props}
  />
)

export default Picker
